import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MovablePropertyBlock } from '../../components/generaldata/generaldatapages/movableproperty';

const MovablePage: FC = () => {
    const {t} = useTranslation();
    const { alias } = useParams<{ alias: string }>();
    

    if (!alias) {
        return <div> alias не найден </div>;
    }

    return (
        <>
            <Helmet>
                <title>Движимое имущество</title>
            </Helmet>
            <MovablePropertyBlock alias={String(alias)}/>
        </>
    );
};

export default MovablePage
